<p-dataView *ngIf="dataView" #dv [value]="products" [paginator]="true" [rows]="9" filterBy="name" layout="grid">
    <ng-template pTemplate="header">
        <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
            <span class="p-input-icon-left p-mb-2 p-mb-md-0">
                <i class="pi pi-search"></i>
                <input type="search" pInputText placeholder="Search by Name" (input)="dv.filter($event.target.value)">
            </span>
            <p-dataViewLayoutOptions></p-dataViewLayoutOptions>
        </div>
    </ng-template>
    <ng-template let-productLists pTemplate="list">
        <div class="p-grid">
            <div *ngFor="let product of productLists" class="p-col-12">
                <p-card class="product-item">
                    <div class="p-d-flex p-jc-between">
                        <div class="p-text-center">
                            <img [src]="assestBaseUrl + 'images/' + product.img" [alt]="product.name"/>
                            <div class="p-mt-2"><strong>{{product.name}}</strong></div>
                        </div>
                        <div class="p-d-flex p-flex-column p-text-right">
                            <div>
                                <p-button label="Install Now" (click)="installBtn()" *ngIf="showInstall"></p-button>
                                <span class="pi pi-spin pi-spinner" *ngIf="showSpin"></span>
                                <p-button icon="pi pi-check" (click)="uninstallBtn()" *ngIf="showInstalled"></p-button>
                            </div>
                            <p-button class="p-mt-auto" label="Details" (click)="changeTableView()" *ngIf="showSetup"></p-button>
                        </div>
                    </div>
                    <div class="p-mt-2 leaddescName" (click)="showMoreInfo(product)">
                        {{(product.description.length>22) ? (product.description | slice:0:22) + '... More' : product.description}}
                    </div>
                </p-card>
            </div>
        </div>
    </ng-template>
    <ng-template let-productLists pTemplate="grid">
        <div class="p-grid">
            <div *ngFor="let product of productLists" class="p-col-12 p-md-4">
                <p-card class="product-item">
                    <div class="p-d-flex p-jc-between">
                        <div class="p-text-center">
                            <img [src]="assestBaseUrl + 'images/' + product.img" [alt]="product.name"/>
                            <div class="p-mt-2"><strong>{{product.name}}</strong></div>
                        </div>
                        <div>
                            <p-button label="Install Now" (click)="installBtn()" *ngIf="showInstall"></p-button>
                            <span class="pi pi-spin pi-spinner" *ngIf="showSpin"></span>
                            <p-button icon="pi pi-check" (click)="uninstallBtn()" *ngIf="showInstalled"></p-button>
                        </div>
                    </div>
                    <div class="p-d-flex p-jc-between">
                        <div class="p-mt-2 leaddescName" (click)="showMoreInfo(product)">
                            {{(product.description.length>22) ? (product.description | slice:0:22) + '... More' : product.description}}
                        </div>
                        <div>
                            <p-button label="Details" (click)="changeTableView()" *ngIf="showSetup"></p-button>
                        </div>
                    </div>
                </p-card>
            </div>
        </div>
    </ng-template>
</p-dataView>
<p-table *ngIf="!dataView" [value]="ecommerceData">
    <ng-template pTemplate="caption">
        <div class="table-header">
            <p-button icon="pi pi-arrow-left" label="Back" (click)="backDataView()"></p-button>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th>Name</th>
            <th>Data Source</th>
            <th>is Active</th>
            <th>Pause/Resume</th>
            <th>Action</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product>
        <tr>
            <td>{{product.name}}</td>
            <td>{{product.dataSource}}</td>
            <td class="p-col-2 action">
                <p-button (click)="confirm(product)" icon="pi pi-check" label="Yes"
                *ngIf="product.isActive"></p-button>
                <p-button (click)="confirm(product)" icon="pi pi-times" label="No"
                *ngIf="!product.isActive"></p-button>
            </td>
            <td class="p-col-2 action">
                <p-button (click)="confirm2(product)" label="Resume" *ngIf="product.status"></p-button>
                <p-button (click)="confirm2(product)" label="Pause" *ngIf="!product.status"></p-button>
            </td>
            <td class="action">
                <span class="btnBars p-mr-0" pTooltip="Edit"
                tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                <span class="btnBars p-mr-0" pTooltip="Key"
                tooltipPosition="top"><i class="pi pi-key" (click)="editConnect()"></i></span>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-dialog header="Connection Info" [(visible)]="displayConnection" [modal]="true" [responsive]="true"
  [style]="{width: '60vw'}">
  <div class="card">
    <div class="p-field p-formgrid p-grid">
      <div class="p-col-12 p-md-6">
        <label>Client ID</label>
        <div class="p-d-flex  p-jc-between">
            <input #clientId type="text" pInputText [(ngModel)]="tempConnection.clientID"
            style="opacity: 1;" disabled />
            <p-button icon="pi pi-copy" pTooltip="Copy" tooltipPosition="top" class="p-ml-2"
            (click)="copyInputMessage(clientId)"></p-button>
        </div>
      </div>
      <div class="p-col-12 p-md-6">
        <label>Auth Token</label>
        <div class="p-d-flex  p-jc-between">
            <input #token type="text" pInputText [(ngModel)]="tempConnection.token" style="opacity: 1;" disabled />
            <p-button icon="pi pi-copy" pTooltip="Copy" tooltipPosition="top" class="p-ml-2"
            (click)="copyInputMessage(token)"></p-button>
        </div>
      </div>
    </div>
  </div>
  <p-footer>
    <button type="button" pButton (click)="displayConnection=false" label="Cancel" class="p-button-secondary"></button>
    <button type="button" pButton label="Save"></button>
  </p-footer>
</p-dialog>

<p-dialog header="Information details" [(visible)]="displayMoreInfo" [modal]="true" [responsive]="true"
  [style]="{width: '60vw'}">
  <div class="card">
    <div class="p-field p-formgrid p-grid">
      {{fullInfo?.description}}
    </div>
  </div>
  <p-footer>
    <button type="button" pButton (click)="displayMoreInfo=false" label="Cancel" class="p-button-secondary"></button>
    <button type="button" pButton label="Save"></button>
  </p-footer>
</p-dialog>
